// Показывали ли игроку объяснение механики «Кристаллы за рейтинг».
// Именно localStorage: знакомство разовое и локальное для устройства, как и
// приветственное напоминание о заданиях (см. questsReminderStorage)
export const RATING_CRYSTALS_INTRO_SHOWN_STORAGE_KEY = 'ratingCrystalsIntroShown';

/**
 * Нужно ли показать объяснение. Недоступный localStorage (Safari в приватном
 * режиме) — не повод молчать: лучше показать лишний раз, чем не показать
 * вовсе
 */
export const checkIfRatingCrystalsIntroPending = () => {
  try {
    return window.localStorage.getItem(RATING_CRYSTALS_INTRO_SHOWN_STORAGE_KEY) !== '1';
  } catch (e) {
    return true;
  }
};

/** Отметить показ — ставится по кнопке «Отлично!», а не по факту появления */
export const rememberRatingCrystalsIntroShown = () => {
  try {
    window.localStorage.setItem(RATING_CRYSTALS_INTRO_SHOWN_STORAGE_KEY, '1');
  } catch (e) {
    // Работаем без localStorage: объяснение покажется и в следующий раз
  }
};
